/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import * as Roles from '../../../constants/role';
import * as selectorsAportes from '../../../store/aporte/reducer';
import * as actionsAportes from '../../../store/aporte/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import moment from 'moment';

import {
  InputV2,
  DialogDefaultV2,
  DatePickerV2,
  NumberInputV2,
  UsuarioSelectV2,
  ArquivoContainerV2,
} from '../../../components/v2';

const schema = {
  valor: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inspetorId: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const Formulario = ({ saveAporte, updateAporte, selectedAporte, open, id, onClose, findAporteById, authData }) => {
  const [values, setValues] = useState({
    data: moment().valueOf(),
    dataTimestamp: moment().valueOf(),
    dataInclusao: moment().valueOf(),
    dataInclusaoTimestamp: moment().valueOf(),
    usuarioId: authData.id,
    usuarioName: authData.nome,
    arquivos: [],
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setValues({
      data: moment().valueOf(),
      dataTimestamp: moment().valueOf(),
      dataInclusao: moment().valueOf(),
      dataInclusaoTimestamp: moment().valueOf(),
      usuarioId: authData.id,
      usuarioName: authData.nome,
      arquivos: [],
    });
  }, [open]);

  const onSave = () => {
    const erros = validate(values, schema) || {};

    setErrors(erros);
    if (!erros || Object.keys(erros).length === 0) {
      if (values.id) updateAporte(values, saveCallback);
      else saveAporte(values, saveCallback);
    }
  };

  const saveCallback = (success) => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({});
    onClose(isSave);
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Aporte"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Inspetor/Ajudante/Observador"
            onSelect={(inspetorId) =>
              setValues({
                ...values,
                inspetorId,
              })
            }
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            value={values.inspetorId}
            isRequired
            error={errors && errors.inspetorId}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
          <NumberInputV2
            error={errors && errors.valor}
            isRequired
            label="Valor"
            onChange={(valor) =>
              setValues({
                ...values,
                valor,
              })
            }
            value={values.valor}
            format="##,######"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
          <DatePickerV2
            label="Data"
            onChange={(data) =>
              setValues({
                ...values,
                data: data.valueOf(),
              })
            }
            value={values.data}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
          <InputV2
            label="Criado Por"
            value={values.usuarioName}
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
          <InputV2
            label="Data Inclusão"
            value={
              values.dataInclusaoTimestamp
                ? moment(Number(values.dataInclusaoTimestamp)).format('DD/MM/YYYY HH:mm')
                : moment().format('DD/MM/YYYY HH:mm')
            }
            disabled
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
          <InputV2
            label="Observação"
            name="descricao"
            onChange={handleChange}
            value={values.descricao}
            rows={3}
            multiline
          />
        </Grid>
        <ArquivoContainerV2
          arquivos={values.arquivos}
          onSave={(arquivos) => setValues({ ...values, arquivos })}
        />
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  findAporteById: PropTypes.func.isRequired,
  saveAporte: PropTypes.func.isRequired,
  updateAporte: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

Formulario.defaultValue = {
  selectedAporte: null,
  id: null,
};

const mapStateToProps = (state) => ({
  selectedAporte: selectorsAportes.getSelectedAporte(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsAportes,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
